import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NonChevronApplicationPermissionUpdateRequest } from 'src/app/models/graph/applications/UpdateNonChevronApplicationPermissionRequest';

@Component({
    selector: 'request-details-non-chevron-permissions-update',
    templateUrl: './request-details-non-chevron-permissions-update.html',
})
export class RequestDetailsNonChevronPermissionsUpdate implements OnInit {
    @Input() requestData: NonChevronApplicationPermissionUpdateRequest;
    @Output() doneLoading = new EventEmitter<boolean>();
    displayColumns: string[] = ['permissionId', 'servicePrincipalId', 'preapproved', 'owners']

    constructor(
        
    ) { }  

    ngOnInit() {
        this.doneLoading.emit(true);
    }
}
